import { useDialog } from '../../../hooks';
import { ReactComponent as RappiTenderoBlackIcon } from '../../../../../assets/images/icons/rappitendero_black.svg';
import { ReactComponent as CargoOrderIcon } from '../../../../../assets/images/icons/papers.svg';
import { ReactComponent as QuestionIcon } from '../../../../../assets/images/icons/question.svg';
import {
  CargoAnalytics,
  OPTION_VALUES,
} from '../../../../../business/cargo/analytics';
import { useHeader } from '../hooks/useHeader';
import { HOW_WORKS_CARGO_URL } from '../../../../../business/cargo';
import { useHeaderLang } from '../hooks/useHeaderLang';

export const getDropdownActions = () => {
  const {
    requestRappiTenderoActionTitleText,
    requestRappiTenderoActionDescriptionText,
    cargoOrdersActionTitleText,
    cargoOrdersActionDescriptionText,
    howCargoWorksActionTitleText,
    howCargoWorksActionDescriptionText,
  } = useHeaderLang();

  const { setStatus, partnerId } = useHeader();
  const { openDialog } = useDialog();

  return [
    {
      icon: RappiTenderoBlackIcon,
      title: requestRappiTenderoActionTitleText,
      description: requestRappiTenderoActionDescriptionText,
      matchWithIsEnabled: true,
      action: () => {
        openDialog();
        setStatus('form');
        CargoAnalytics.whenClickOption(partnerId, OPTION_VALUES.request_rt);
      },
    },
    {
      icon: CargoOrderIcon,
      title: cargoOrdersActionTitleText,
      description: cargoOrdersActionDescriptionText,
      matchWithIsEnabled: true,
      action: () => {
        openDialog();
        setStatus('list');
        CargoAnalytics.whenClickOption(partnerId, OPTION_VALUES.orders);
      },
    },
    {
      icon: QuestionIcon,
      title: howCargoWorksActionTitleText,
      description: howCargoWorksActionDescriptionText,
      matchWithIsEnabled: false,
      action: () => {
        window.open(HOW_WORKS_CARGO_URL, '_blank');
        CargoAnalytics.whenClickOption(
          partnerId,
          OPTION_VALUES.how_cargo_works,
        );
      },
    },
  ];
};
